/* eslint-disable */
import { FormGroup, Label, Input, Button } from "reactstrap";

import styles from "./Form.module.css";

const Step4 = (props) => {
  if (props.currentStep !== 4) {
    return null;
  }

  return (
    <>
      {props.isCreating && <h4>{props.stepTitle}</h4>}
      <FormGroup>
        <Label for="password">Nome:</Label>
        <Input
          type="text"
          name="linkName"
          id="linkName"
          placeholder="Insira o nome do site ou origem da URL"
          value={props.linkName}
          onChange={props.handleLinkChange}
        />
        <Label className="mt-4" for="password">
          URL
        </Label>
        <Input
          type="text"
          name="linkUrl"
          id="linkUrl"
          placeholder="Insira a url"
          value={props.linkUrl}
          onChange={props.handleLinkChange}
        />
        <div className="centerr">
          <Button
            onClick={props.handleNewLink}
            className={styles.button_form}
            color="primary mt-5"
          >
            Adicionar Link
          </Button>
        </div>
      </FormGroup>
    </>
  );
};

export default Step4;
